import type { FC } from 'react';

import { Form } from '../../Form.tsx';
import type { GenericFormProps } from '../../GenericFormProps.ts';
import { schemaWithLocationRefinement } from './schema.ts';
import { WhereAndWhen } from './WhereAndWhen.tsx';

export const WhereAndWhereForm: FC<GenericFormProps<typeof WhereAndWhen, typeof schemaWithLocationRefinement>> = ({
  onSubmit,
  buttonSlot,
  defaultValues,
}) => (
  <Form
    buttonSlot={buttonSlot}
    defaultValues={defaultValues}
    formContentElement={WhereAndWhen}
    schema={schemaWithLocationRefinement}
    onSubmit={onSubmit}
  />
);
